const state = {
	enableSmoothScrollbar: true,
	smoothScrollbarInstance: null,
	scrollDamping: 0.2,
	bannerCases: [0, 1, 2],
}
const getters = {}

const mutations = {
	SET_BANNER_CASES: (state, indexes) => state.bannerCases = indexes,
	SET_SMOOTH_SCROLLBAR_INSTANCE: (state, instance) => state.smoothScrollbarInstance = instance,
	SET_SCROLL_TO: (state, yPos) => {
		if (state.smoothScrollbarInstance) {
			state.smoothScrollbarInstance.scrollTo(0, yPos)
		} else {
			window.scrollTo(0, yPos)
		}
	}
}
const actions = {}

export default{
    state,getters,mutations,actions
}
